import { ClosingPeriod } from '@core/hera-models';

export function getActiveClosingPeriod(
  closingPeriods: ClosingPeriod[] | null | undefined,
  referenceDate: Date = new Date()
): ClosingPeriod | undefined {
  const now = referenceDate.getTime();
  return closingPeriods?.find((period) => {
    const beginDate = startOfDay(period.begin_date);
    const endDate = period.end_date ? endOfDay(period.end_date) : undefined;
    return now >= beginDate && (endDate === undefined || now <= endDate);
  });
}

function startOfDay(dateString: string): number {
  const date = new Date(dateString);
  date.setUTCHours(0, 0, 0, 0);
  return date.getTime();
}

function endOfDay(dateString: string): number {
  const date = new Date(dateString);
  date.setUTCHours(23, 59, 59, 999);
  return date.getTime();
}
